// AWIN Affiliate Modul
import {TrackingModule} from "./emu/lokl-track";

export function loadAwinAffiliateModule(data, adContainer) {

    if (data.awinAdHtml) {
        adContainer.innerHTML = data.awinAdHtml;
        adContainer.addEventListener('click', function() {
            TrackingModule.trackEvent('AwinAdClick', { adId: data.adId });
        });
    } else if (data.awinScriptUrl) {
        var script = document.createElement('script');
        script.async = true;
        script.src = data.awinScriptUrl;
        script.onload = function() {
            if (window.awinAd) {
                window.awinAd.onClick = function(adData) {
                    TrackingModule.trackEvent('AwinAdClick', adData);
                };
            }
        };
        adContainer.appendChild(script);
    } else {
        console.warn('Keine gültigen AWIN-Daten gefunden.');
    }
}